import { makeStyles } from "@mui/styles";
import theme from "mui/theme";

export const menuItemSubcategoryStyles = makeStyles(() => ({
  menu_item__active: {
    color: theme.palette.primary.dark,
  },
}));
